// Làm phẳng bản ghi school_users: thông tin cá nhân nằm ở user, lớp ở class, phần còn lại ở metadata
export const transformStudentData = (student: any) => {
  const user = student.user || {};
  const school = student.school || {};
  const classInfo = student.class || {};
  const metadata = student.metadata || {};
  
  return {
    id: student.id,
    code: user.code || '',
    name: user.name || '',
    email: user.email || '',
    phone: user.phone || '',
    role: user.role || student.role || 'student',
    // status là trạng thái học tập (school_users, BE lọc theo trường này); accountStatus là trạng thái tài khoản
    status: student.status || 'active',
    accountStatus: user.status || 'active',
    active: user.active !== undefined ? user.active : true,
    
    // School information
    schoolId: student.schoolId || school.id || '',
    schoolName: school.name || '',
    schoolCode: school.code || '',
    schoolType: school.type || '',
    schoolLevel: school.level || '',
    
    // Class information
    classId: student.classId || classInfo.id || '',
    className: classInfo.name || '',
    schoolYear: classInfo.schoolYear || '',
    grade: classInfo.grade || '',
    classStatus: classInfo.status || '',
    
    // Student specific information
    studentId: metadata.studentId || '',
    dateOfBirth: metadata.dateOfBirth || '',
    gender: metadata.gender || '',
    address: metadata.address || '',
    parentName: metadata.parentName || '',
    parentPhone: metadata.parentPhone || '',
    parentEmail: metadata.parentEmail || '',
    emergencyContact: metadata.emergencyContact || '',
    emergencyPhone: metadata.emergencyPhone || '',
    enrollmentDate: metadata.enrollmentDate || '',
    graduationDate: metadata.graduationDate || '',
    academicLevel: metadata.academicLevel || '',
    gpa: metadata.gpa || 0,
    attendance: metadata.attendance || 0,
    
    // Metadata information
    createdViaImport: metadata.created_via_import || false,
    importedAt: metadata.imported_at || '',
    originalStudentCode: metadata.original_student_code || '',
    originalStudentName: metadata.original_student_name || '',
    classUpdatedViaImport: metadata.class_updated_via_import || false,
    classUpdatedAt: metadata.class_updated_at || '',
    
    // Timestamps
    createdAt: student.created_at || '',
    updatedAt: student.updated_at || '',
    
    // Keep original data for reference
    originalData: student
  };
};
